import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import App from "./App.tsx";
import "./index.css";
import { initSentry, Sentry } from "./lib/sentry";

// Initialise Sentry avant le premier render pour capturer les erreurs de bootstrap
initSentry();

// Initialise PostHog (Session Replay beta) — silencieux si les env vars sont absentes
const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;
if (posthogKey && posthogHost) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    // Session Replay actif — enregistre videos des sessions
    disable_session_recording: false,
    session_recording: {
      // Confidentialite : masque TOUS les inputs (mots de passe, textes saisis, etc.)
      maskAllInputs: true,
    },
    // Capture automatique des pageviews et clics (defaut PostHog)
    capture_pageview: true,
    autocapture: true,
  });
}

// Enregistre le Service Worker pour PWA + push notifications (Juliette Pro V2).
// Echec silencieux : si le SW ne s'installe pas, l'app reste fonctionnelle sans push.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.error("SW registration failed:", err);
      Sentry.captureException(err);
    });
  });
}

try {
  createRoot(document.getElementById("root")!).render(<App />);
} catch (err) {
  Sentry.captureException(err);
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#09090b;color:#fafafa;font-family:system-ui,sans-serif;padding:2rem">
        <div style="max-width:480px;text-align:center">
          <h1 style="font-size:1.5rem;margin-bottom:1rem">Erreur de chargement</h1>
          <pre style="background:#1c1c1e;padding:1rem;border-radius:8px;font-size:0.85rem;overflow:auto;text-align:left;color:#f87171">${err instanceof Error ? err.message : String(err)}</pre>
          <button onclick="location.reload()" style="margin-top:1.5rem;padding:0.5rem 1.5rem;background:#3b82f6;color:white;border:none;border-radius:6px;cursor:pointer;font-size:0.9rem">Rafraichir</button>
        </div>
      </div>`;
  }
}
